import React from 'react';
import NoteEvent from '../../../../../../common/components/activity-events/note/NoteEvent';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import {
  deleteSupplierTimelineNoteThunk,
  editSupplierTimelineNoteThunk,
} from '../../../../../../store/thunks/suppliers/suppliersViewPageThunks';
import { BasicNoteEventProps } from '../../../../../../core/types/coreTypes';
import { useNoteActivityLog } from '../../../../../../common/hooks/useNoteActivityLog';

const SupplierNoteEvent: React.FC<BasicNoteEventProps> = ({ id, content = '', initiator = '' }) => {
  const {
    dispatch,
    value,
    setValue,
    isEditModal,
    isConfirmationModal,
    setIsConfirmationModal,
    closeHandle,
    menuItems,
  } = useNoteActivityLog(content);

  const editHandle = () => {
    id && dispatch(editSupplierTimelineNoteThunk({
      id,
      content: value.trim(),
      closeModal: closeHandle,
    }));
  };

  const deleteHandle = () => {
    id && dispatch(deleteSupplierTimelineNoteThunk({
      id,
      closeModal: () => setIsConfirmationModal(false),
    }));
  };

  return (
    <NoteEvent
      content={content}
      menuItems={menuItems}
      value={value}
      setValue={setValue}
      isEditModal={isEditModal}
      closeEditModal={closeHandle}
      editHandle={editHandle}
      isConfirmationModal={isConfirmationModal}
      setIsConfirmationModal={setIsConfirmationModal}
      deleteHandle={deleteHandle}
      initiator={initiator}
      permission={PermissionEnum.SupplierEditDeleteNotesOfOtherUsersInActivityLog}
    />
  );
};

export default SupplierNoteEvent;
